export default "__VITE_ASSET__C5W5MrYg__$_?nuxt_component=async&nuxt_component_name=IconPaypalLogo&nuxt_component_export=default__"